import { createFileRoute } from "@tanstack/react-router";
import { CrudShellHeader } from "@/components/ds";
import { ClinicalPageShell } from "@/components/clinical";
import { ReorderSection } from "@/components/operaciones/operaciones-sections";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";

export const Route = createFileRoute("/app/operaciones/recompras")({
  component: OperacionesRecomprasPage,
  head: () => ({ meta: [{ title: "Recompras — Operaciones" }] }),
});

function OperacionesRecomprasPage() {
  const tid = useWorkspaceTenantId();

  return (
    <div>
      <CrudShellHeader title="Recompras sugeridas" backHref="/app/operaciones" backLabel="Volver a Abastecimiento" />
      <ClinicalPageShell offset="none" className="pt-6">
        {tid ? <ReorderSection tid={tid} /> : null}
      </ClinicalPageShell>
    </div>
  );
}
